import { render, staticRenderFns } from "./ConstructionEditForm.vue?vue&type=template&id=4f9bdc64&scoped=true&lang=pug&"
import script from "./ConstructionEditForm.vue?vue&type=script&lang=ts&"
export * from "./ConstructionEditForm.vue?vue&type=script&lang=ts&"
import style0 from "./ConstructionEditForm.vue?vue&type=style&index=0&id=4f9bdc64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9bdc64",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCol,VDatePicker,VMenu,VRow,VSelect,VTextField,VTextarea})
